module.exports = __webpack_public_path__ + "27d5a4fa7b0a751e838b556d6b2e8f20.MP3";